import { useAdminContent } from "@/context/AdminContentContext";
import { Field, Panel, TextArea, TextInput } from "@/components/admin/Field";

export default function EditComunidade() {
  const { draft, update } = useAdminContent();
  const c = draft.community;
  const set = (k) => (v) => update("community", { [k]: v });
  return (
    <Panel title="Texto da comunidade Discord" description="Secção apresentada na página inicial com o widget oficial.">
      <Field label="Etiqueta superior" id="community-eyebrow"><TextInput id="community-eyebrow" value={c.eyebrow} onChange={set("eyebrow")} maxLength={60} /></Field>
      <Field label="Título" id="community-title"><TextInput id="community-title" value={c.title} onChange={set("title")} maxLength={160} /></Field>
      <Field label="Texto" id="community-text"><TextArea id="community-text" value={c.text} onChange={set("text")} maxLength={800} /></Field>
      <Field label="Texto do botão" id="community-button"><TextInput id="community-button" value={c.button_label} onChange={set("button_label")} maxLength={40} /></Field>
    </Panel>
  );
}
